import {NotFoundPage} from "pages/404";
import type {AppRouteProps} from "../types";

export const notFoundPageRoute: AppRouteProps = {
  path: "*",
  element: <NotFoundPage/>,
};
